import { render, staticRenderFns } from "./AzDistributorsFinanceReadOnlyPanel.vue?vue&type=template&id=140e49a0"
import script from "./AzDistributorsFinanceReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./AzDistributorsFinanceReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports